module.exports = __webpack_public_path__ + "media/images/dark-mode-4d13cbe4.png";